import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'
import Select from 'material-ui/Select'
import MenuItem from 'material-ui/Menu/MenuItem';
import styles from '../styles'

class Toolbar extends React.Component {

  toggle() {
    this.setState({
      search: !this.state.search
    })
  }

  render() {

    const {
      classes,
      translate,
      toggle,
      add,
      importTest,
      jobsDefaultOrder,
      jobOrderSelectOptions,
      changeJobsDefaultOrder,
      signalRUpdate
    } = this.props

    return (
      <div>
        {/*
         <Tooltip title="Print">
          <Button aria-label="Print" className={classes.button} fab mini onClick={() => toggle()}>
            <Icon>print</Icon>
          </Button>
        </Tooltip>
         */}
        <Select
          value={jobsDefaultOrder.name}
          onChange={changeJobsDefaultOrder}
          variant="outlined"
          className={classes.jobOrder}
        >
          {Object.keys(jobOrderSelectOptions).map((option, index) => {
            return (<MenuItem
              key={index}
              value={option}
            >
              {translate(option)}
            </MenuItem>)
          })}
        </Select>

        <Tooltip title={translate("tooltip_create_job")} disableTriggerFocus={true}>
          <Button aria-label="Create Job" className={classes.button} fab mini onClick={() => add()} id="create-job">
            <Icon>add</Icon>
          </Button>
        </Tooltip>
        <Tooltip title={translate("general_import")} disableTriggerFocus={true}>
          <Button aria-label="Import" className={classes.button} fab mini onClick={() => importTest()}>
            <Icon>cloud_download</Icon>
          </Button>
        </Tooltip>

        {/*
        Not sure if this is really needed as we have no global search functionality
        <Tooltip title="Search">
          <Button aria-label="Search" className={classes.button} fab mini onClick={() => toggle()}>
            <Icon>search</Icon>
          </Button>
        </Tooltip>
        */}
        <Tooltip title={translate("tooltip_search")} disableTriggerFocus={true}>
          <Button aria-label="Search" className={classes.button} fab mini onClick={() => toggle()}>
            <Icon>search</Icon>
          </Button>
        </Tooltip>

        { signalRUpdate && <Tooltip title={translate("auto_refresh_enabled")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='accent'
            fab
            mini
            onClick={() => {}}
          >
            <Icon>sync</Icon>
          </Button>
        </Tooltip>
        }
      </div >
    )
  }
}


export default withStyles(styles)(Toolbar)
